import { render } from "./SeoJsonLdComponent.vue?vue&type=template&id=1595994e"
import script from "./SeoJsonLdComponent.vue?vue&type=script&lang=ts"
export * from "./SeoJsonLdComponent.vue?vue&type=script&lang=ts"
script.render = render

export default script